module.exports = __webpack_public_path__ + "img/about_title_m.e9755f59.png";